<div class="mat-body-1 p-10 rounded m-t-10">
    <div class="addresslist-container">
        <strong>
            <i-tabler name="home-link" class="m-r-10 icon-18" />
            {{ 'LABEL.PER_ADDRESS' | translate }}
        </strong>

        <div class="address-group">
            <div class="row m-t-10">
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.PINCODE_LABEL' | translate }}</mat-label>
                        <input matInput placeholder="pincode" [(ngModel)]="patient.address[0].pincode"
                            name="Permanentpincode" #Permanentpincode="ngModel" pattern="^[1-9][0-9]{5}$" minlength="6" maxlength="6" appAllowOnlyDigits>
                       <mat-error *ngIf="Permanentpincode.hasError('minlength')">
                                {{ 'REQUIRED.MINIMUM6' | translate }}
                                </mat-error>

                                <mat-error *ngIf="!Permanentpincode.hasError('minlength') && Permanentpincode.hasError('pattern')">
                                {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                                </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.COUNTRY' | translate }}</mat-label>
                        <input matInput placeholder="Country" [(ngModel)]="patient.address[0].country"
                            name="Permanentcountry" #Permanentcountry="ngModel" pattern="^[a-zA-Z\s]+$"
                            (blur)="patient.address[0].country = patient.address[0].country ? patient.address[0].country.trimEnd() : ''">
                        <mat-error
                            *ngIf="Permanentcountry.invalid && (Permanentcountry.dirty || Permanentcountry.touched)">
                            <span *ngIf="Permanentcountry.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.STATE' | translate }}</mat-label>
                        <input matInput placeholder="State" [(ngModel)]="patient.address[0].state"
                            name="Permanentstate" #Permanentstate="ngModel" pattern="^[a-zA-Z\s]+$"
                            (blur)="patient.address[0].state = patient.address[0].state ? patient.address[0].state.trimEnd() : ''">
                        <mat-error *ngIf="Permanentstate.invalid && (Permanentstate.dirty || Permanentstate.touched)">
                            <span *ngIf="Permanentstate.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.DISTRICT' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'LABEL.DISTRICT' | translate }}" [(ngModel)]="patient.address[0].district"
                            name="Permanentdistrict" #Permanentdistrict="ngModel" pattern="^[a-zA-Z\s]+$"
                            (blur)="patient.address[0].district = patient.address[0].district ? patient.address[0].district.trimEnd() : ''">
                        <mat-error
                            *ngIf="Permanentdistrict.invalid && (Permanentdistrict.dirty || Permanentdistrict.touched)">
                            <span *ngIf="Permanentdistrict.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.AREA' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'LABEL.AREA' | translate }}" [(ngModel)]="patient.address[0].area" name="Permanentarea"
                            #Permanentarea="ngModel" pattern="^[a-zA-Z\s]+$"
                            (blur)="patient.address[0].area = patient.address[0].area ? patient.address[0].area.trimEnd() : ''">
                        <mat-error *ngIf="Permanentarea.invalid && (Permanentarea.dirty || Permanentarea.touched)">
                            <span *ngIf="Permanentarea.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>{{ 'LABEL.TALUKA' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'LABEL.TALUKA' | translate }}" [(ngModel)]="patient.address[0].taluka"
                            name="Permanenttaluka" #Permanenttaluka="ngModel" pattern="^[a-zA-Z\s]+$"
                            (blur)="patient.address[0].taluka = patient.address[0].taluka ? patient.address[0].taluka.trimEnd() : ''">
                        <mat-error
                            *ngIf="Permanenttaluka.invalid && (Permanenttaluka.dirty || Permanenttaluka.touched)">
                            <span *ngIf="Permanenttaluka.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
                        <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}1</mat-label>
                        <textarea matInput rows="2" [(ngModel)]="patient.address[0].address1"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
                        <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}2</mat-label>
                        <textarea matInput rows="2" [(ngModel)]="patient.address[0].address2"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>


</div>
<div class="mat-body-1 p-10 rounded m-t-0">
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel class="no-shadow">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong style="display: flex;">
                        <i-tabler name="home-link" class="m-r-10 icon-18"></i-tabler>
                        {{ 'LABEL.CUR_ADDRESS' | translate }}
                    </strong>
                </mat-panel-title>

            </mat-expansion-panel-header>
            <div class="addresslist-current-container">
                <div class="same-as-about-container">
                    <mat-checkbox [color]="'primary'" (change)="onSameAsAboutChange($event)">
                        {{ 'LABEL.SAME_AS_ABOUT' | translate }}
                    </mat-checkbox>
                </div>
                <div class="address-group">
                    <div class="row m-t-10">
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.PINCODE_LABEL' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.PINCODE_LABEL' | translate }}" [(ngModel)]="patient.address[1].pincode"
                                    name="Currentpincode" #Currentpincode="ngModel" pattern="^[1-9][0-9]{5}$"
                                    maxlength="6" minlength="6">
                               <mat-error *ngIf="Currentpincode.hasError('minlength')">
                                {{ 'REQUIRED.MINIMUM6' | translate }}
                                </mat-error>

                                <mat-error *ngIf="!Currentpincode.hasError('minlength') && Currentpincode.hasError('pattern')">
                                {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.COUNTRY' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.COUNTRY' | translate }}" [(ngModel)]="patient.address[1].country"
                                    name="Currentcountry" #Currentcountry="ngModel" pattern="^[a-zA-Z\s]+$"
                                    (blur)="patient.address[1].country = patient.address[1].country ? patient.address[1].country.trimEnd() : ''">
                                <mat-error
                                    *ngIf="Currentcountry.invalid && (Currentcountry.dirty || Currentcountry.touched)">
                                    <span *ngIf="Currentcountry.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' |
                                        translate }}</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.STATE' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.STATE' | translate }}" [(ngModel)]="patient.address[1].state"
                                    name="Currentstate" #Currentstate="ngModel" pattern="^[a-zA-Z\s]+$"
                                    (blur)="patient.address[1].state = patient.address[1].state ? patient.address[1].state.trimEnd() : ''">
                                <mat-error *ngIf="Currentstate.invalid && (Currentstate.dirty || Currentstate.touched)">
                                    <span *ngIf="Currentstate.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                        }}</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.DISTRICT' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.DISTRICT' | translate }}" [(ngModel)]="patient.address[1].district"
                                    name="Currentdistrict" #Currentdistrict="ngModel" pattern="^[a-zA-Z\s]+$"
                                    (blur)="patient.address[1].district = patient.address[1].district ? patient.address[1].district.trimEnd() : ''">
                                <mat-error
                                    *ngIf="Currentdistrict.invalid && (Currentdistrict.dirty || Currentdistrict.touched)">
                                    <span *ngIf="Currentdistrict.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' |
                                        translate }}</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.AREA' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.AREA' | translate }}" [(ngModel)]="patient.address[1].area"
                                    name="Currentarea" #Currentarea="ngModel" pattern="^[a-zA-Z\s]+$"
                                    (blur)="patient.address[1].area = patient.address[1].area ? patient.address[1].area.trimEnd() : ''">
                                <mat-error *ngIf="Currentarea.invalid && (Currentarea.dirty || Currentarea.touched)">
                                    <span *ngIf="Currentarea.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' | translate
                                        }}.</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <mat-label>{{ 'LABEL.TALUKA' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.TALUKA' | translate }}" [(ngModel)]="patient.address[1].taluka"
                                    name="Currenttaluka" #Currenttaluka="ngModel" pattern="^[a-zA-Z\s]+$"
                                    (blur)="patient.address[1].taluka = patient.address[1].taluka ? patient.address[1].taluka.trimEnd() : ''">
                                <mat-error
                                    *ngIf="Currenttaluka.invalid && (Currenttaluka.dirty || Currenttaluka.touched)">
                                    <span *ngIf="Currenttaluka.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' |
                                        translate }}</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
                                <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}1</mat-label>
                                <textarea matInput rows="2" [(ngModel)]="patient.address[1].address1"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                            <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
                                <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}2</mat-label>
                                <textarea matInput rows="2" [(ngModel)]="patient.address[1].address2"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>